"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Heads = function Heads(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react.default.createElement("path", {
    fill: offsetColor,
    d: "M482.98 261.8c5.47 50.02-11.73 95.98-42.45 128.82-24.6 26.3-39.63 61.76-39.63 97.38H243.74v-41.5c0-13.12-4.12-22.5-17.04-22.5H215c-19.37 0-43.34-17.22-43.34-36.9V328H151.7c-8.6 0-14.27-9.26-10.56-17.14l46.43-98.75c5.89-12.51 12.93-24.52 21.7-35.15 18.43-22.37 42.87-39.75 70.3-49.15 45.69-15.65 96.8-7.18 136.13 20.44 37.36 26.21 62.3 68.12 67.28 113.56z"
  }), _react.default.createElement("g", {
    fill: borderColor
  }, _react.default.createElement("path", {
    d: "M368.9 512H211.73a8 8 0 01-8-8v-41.5c0-14.5-5.22-14.5-9.03-14.5H183c-23.25 0-51.35-20.03-51.35-44.9V352H119.7c-6.72 0-12.9-3.44-16.55-9.18a20.03 20.03 0 01-1.23-19.38l46.42-98.74c6.8-14.46 14.25-26.5 22.77-36.84 19.78-23.99 45.34-41.84 73.89-51.63 47.45-16.27 101.03-8.24 143.31 21.46 39.06 27.42 65.47 72 70.63 119.25 5.46 49.8-10.79 99.05-44.55 135.15-23.83 25.44-37.5 58.94-37.5 91.91a8 8 0 01-8 8zm-149.16-16h141.4c2.02-34.34 16.9-68.51 41.56-94.85 30.57-32.67 45.28-77.31 40.33-122.47-4.68-42.74-28.57-83.08-63.91-107.9-38.13-26.76-86.34-34.02-128.94-19.41-25.76 8.83-48.83 24.97-66.73 46.67-7.66 9.29-14.41 20.23-20.63 33.46l-46.43 98.75c-.87 1.84-.1 3.4.27 3.99a3.6 3.6 0 003.04 1.75h19.96a8 8 0 018 8v59.11c0 14.88 19.92 28.9 35.36 28.9h11.7c9.34 0 25.02 3.96 25.02 30.5V496z"
  }), _react.default.createElement("path", {
    d: "M276.24 512H119.09a8 8 0 01-8-8c0-32.97-13.67-66.47-37.5-91.91-33.76-36.1-50-85.35-44.54-135.15 5.16-47.25 31.57-91.83 70.63-119.25 42.28-29.7 95.85-37.72 143.31-21.46 28.55 9.79 54.11 27.64 73.89 51.63 8.51 10.33 15.97 22.38 22.77 36.84l46.43 98.74a20.05 20.05 0 01-1.24 19.38 19.53 19.53 0 01-16.55 9.17h-11.97v51.11c0 24.87-28.1 44.9-51.35 44.9h-11.7c-3.81 0-9.03 0-9.03 14.5V504a8 8 0 01-8 8zm-149.4-16h141.4v-33.5c0-26.53 15.68-30.5 25.03-30.5h11.7c15.44 0 35.35-14.02 35.35-28.9V344a8 8 0 018-8h19.96a3.6 3.6 0 003.05-1.76 4.11 4.11 0 00.27-4l-46.44-98.74c-6.22-13.23-12.97-24.17-20.63-33.46-17.9-21.71-40.97-37.85-66.73-46.67-42.6-14.6-90.83-7.35-128.94 19.41-35.33 24.83-59.23 65.16-63.9 107.9l-7.96-.86 7.95.86c-4.94 45.16 9.76 89.8 40.34 122.47 24.64 26.34 39.53 60.5 41.56 94.85z"
  }), _react.default.createElement("path", {
    d: "M388 175.36a8 8 0 01-8-8V152c0-75-61.02-136-136-136S108 77 108 152v15.36a8 8 0 11-16 0V152C92 68.18 160.16 0 244 0s152 68.18 152 152v15.36a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M355.9 156.8a8 8 0 01-7.99-7.78C346.37 93.32 299.74 48 244 48S141.61 93.32 140.07 149.02c-.13 4.42-3.89 8.08-8.22 7.78a8 8 0 01-7.78-8.22C125.87 84.3 179.66 32 244 32s118.13 52.3 119.92 116.58a8 8 0 01-7.78 8.21l-.23.01z"
  }), _react.default.createElement("path", {
    d: "M322.86 146.64a8 8 0 01-7.88-6.66C309.1 105.22 279.23 80 244 80s-65.1 25.22-71 59.98a8 8 0 11-15.77-2.68C164.43 94.83 200.92 64 244 64s79.56 30.83 86.78 73.3a8 8 0 01-7.9 9.34z"
  }), _react.default.createElement("path", {
    d: "M289.27 144.17a8 8 0 01-7.57-5.45 39 39 0 00-9.44-14.98A39.46 39.46 0 00243.98 112a39.9 39.9 0 00-37.72 26.78 8 8 0 11-15.12-5.23A55.91 55.91 0 01244 96a55.3 55.3 0 0139.6 16.45 55.05 55.05 0 0113.26 21.16 8 8 0 01-7.58 10.56z"
  })));
};

Heads.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
Heads.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = Heads;
exports.default = _default;